import { render, staticRenderFns } from "./BaseNotificationMessage.vue?vue&type=template&id=43827f6c&"
import script from "./BaseNotificationMessage.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports